import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=3397366d&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"
import style0 from "./DashboardCharts.vue?vue&type=style&index=0&id=3397366d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397366d",
  null
  
)

export default component.exports